import { FormGroup, FormHelperText, Switch, SwitchProps } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import withStyles from "@mui/styles/withStyles";
import { defaultOLTheme, OLTheme } from "contexts/Theme/ThemeProvider";
import { Field, getIn } from "formik";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    switch: {
      color: theme.gray500,
      marginLeft: 0,
      "& label": {
        alignSelf: "flex-start",
        gap: 8,
        margin: 0,
      },
    },
    error: { color: theme.red500 },
    helperText: {
      whiteSpace: "break-spaces",
    },
  }),
);
interface ToggleProps extends SwitchProps {
  className?: string;
  error?: boolean;
  helperText?: string;
  label?: React.ReactNode;
  name?: string;
  "data-test-id"?: string;
  onChange?: (e?: React.ChangeEvent<HTMLInputElement>) => void;
}
export const OLSwitch = withStyles(() => ({
  switchBase: {
    color: defaultOLTheme.gray400,
    "&$checked": {
      color: defaultOLTheme.primary500,
      "& + $track": {
        backgroundColor: defaultOLTheme.primary500,
      },
    },
    "&$disabled": {
      color: defaultOLTheme.gray400,
    },
  },
  track: {
    backgroundColor: defaultOLTheme.gray400,
    opacity: "38%",
  },
  disabled: {
    "&$checked": {
      "& + $track": {
        backgroundColor: defaultOLTheme.primary500,
      },
    },
  },
  checked: {},
}))(Switch);

export function Toggle(props: ToggleProps) {
  const classes = useStyles();

  return (
    <Field name={props.name}>
      {({ field, form, meta }: { field: any; form: any; meta: any }) => {
        return (
          <FormGroup className={`${props.className} ${classes.switch}`}>
            <FormControlLabel
              {...field}
              {...props}
              className={
                !!(meta.error || props.error || getIn(form.status, field.name))
                  ? classes.error
                  : ""
              }
              data-test-id={props["data-test-id"] && props["data-test-id"]}
              disabled={props.disabled}
              control={
                <OLSwitch
                  checked={!!field.value}
                  color="primary"
                  onChange={(e) => {
                    field.onChange(e);
                    props.onChange?.(e);
                  }}
                  value={!!field.value}
                />
              }
              label={props.label}
              name={props.name}
            />
            {(meta.error ||
              props.helperText ||
              getIn(form.status, field.name)) && (
              <FormHelperText
                className={`${
                  !!(
                    meta.error ||
                    props.error ||
                    getIn(form.status, field.name)
                  )
                    ? classes.error
                    : ""
                } ${classes.helperText}`}
              >
                {meta.error ||
                  getIn(form.status, field.name) ||
                  props.helperText}
              </FormHelperText>
            )}
          </FormGroup>
        );
      }}
    </Field>
  );
}
